<script>
    import { Select, Option, Form, FormItem, Input, Checkbox, Message } from 'element-ui';
    import { mapState, mapMutations, mapActions } from 'vuex';
    import Vue from 'vue';
    import Loader from '~/components/loader/components/loader';
    import Panel from '~/components/panel/components/panel';
    import VueButton from '~/components/button/components/button';
    import FormGroup from '~/components/form/components/form_group';
    import ImageCrop from '~/components/image_crop/components/image_crop';
    import ImageCropFormWrap from '~/components/image_crop/components/image_crop_form_wrap';

    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Checkbox);

    export default {
        components: {
            Loader,
            Panel,
            VueButton,
            FormGroup,
            ImageCrop,
            ImageCropFormWrap
        },

        computed: {
            ...mapState('newUserRegistrationForm', [
                'formData',
                'lists',
                'loading',
                'stepActive'
            ]),

            hasProfilePhoto() {
                return this.formData.profileImage.length > 0;
            },

            hasLogoImage() {
                return this.formData.logoImage.length > 0;
            }
        },

        methods: {
            ...mapActions('newUserRegistrationForm', {
                saveUserImage: 'saveUserImage'
            }),

            ...mapMutations('newUserRegistrationForm', {
                updateFormShowingStatus: 'updateFormShowingStatus',
                updateFormData: 'updateFormData',
                updateLoading: 'updateLoading',
                updateStepStatus: 'updateStepStatus',
            }),

            handleLoginClick() {
                window.location.href = '/login';
            },

            handlePreviousClick() {
                this.updateFormShowingStatus({
                    formName: 'generalInfoForm',
                    showingStatus: true
                });

                this.updateFormShowingStatus({
                    formName: 'imageSettingsForm',
                    showingStatus: false
                });

                this.updateStepStatus(1);
            },

            handleProfileImageChange(image) {
                this.updateFormData({
                    profileImage: image
                });

                this.saveUserImage({
                    type: 'profile',
                    field: 'profileImage'
                })
                .then(() => {
                    Message({
                        message: 'Profile image saved',
                        type: 'success'
                    });
                })
                .catch(() => {
                    Message({
                        message: 'Unable to save profile image',
                        type: 'error'
                    });
                });
            },

            handleLogoImageChange(image) {
                this.updateFormData({
                    logoImage: image
                });

                this.saveUserImage({
                    type: 'logo',
                    field: 'logoImage'
                })
                .then(() => {
                    Message({
                        message: 'Logo image saved',
                        type: 'success'
                    });
                })
                .catch(() => {
                    Message({
                        message: 'Unable to save logo image',
                        type: 'error'
                    });
                });
            }
        }
    }
</script>
<template>
    <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInDown"
    >
        <div>
            <div class="row">
                <div class="col-xs-12 col-md-12">
                    <template>
                        <loader :is-loading="loading.saveUserImage"></loader>
                        <panel title="Let's add some images to your profile.">
                            <loader :is-loading="loading.saveUserImage"></loader>
                            <div slot="body">
                                <div class="row">
                                    <div class="col-xs-12 col-md-12">
                                        <p class="form-text m-b-30">These images will be used on any marketing and co-marketing collateral that you or your partners create within Total Expert platform.</p>
                                    </div>
                                    <div class="col-xs-12 col-md-4">
                                        <image-crop-form-wrap
                                            inputName="profile_image"
                                            labelName="Profile Photo"
                                            :allow-crop="false"
                                            :default-image="formData.profileImage"
                                            @image-saved="handleProfileImageChange"
                                        >
                                        </image-crop-form-wrap>
                                    </div>
                                    <div class="col-xs-12 col-md-4">
                                        <image-crop-form-wrap
                                            inputName="logo_image"
                                            labelName="Logo Image"
                                            crop-dialog-title="Upload Logo"
                                            :use-croppie="false"
                                            :default-image="formData.logoImage"
                                            @image-saved="handleLogoImageChange"
                                        >
                                        </image-crop-form-wrap>
                                    </div>

                                </div>
                            </div>
                            <div slot="footer">
                                <div class="row">
                                    <div class="col-xs-12 col-md-12 text-right">
                                        <vue-button type="default" @click="handlePreviousClick">
                                            Previous
                                        </vue-button>
                                        <vue-button type="primary" @click="handleLoginClick">
                                            Sign In
                                        </vue-button>
                                    </div>
                                </div>
                            </div>
                        </panel>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>
<style scoped>
    .form-text {
        line-height: 1;
        font-size: 16px;
    }
</style>